<template>
  <slide-out
    dock="right"
    :size="sideOutCurrentSize"
    :min-size="sideOutMinSize"
    id="dashboard-slideout"
    ref="dashboardSideout"
    :allow-resize="nested ? false : true"
    :append-to="nested ? '' : '#app'"
    :visible.sync="slideouts.active"
    v-on:close="slideoutClose"
    @resize="OnResize">
    <template v-slot:header>
      <v-row class="ma-0 d-flex flex-column dashboardFilters">
        <v-row class="ma-0 d-flex justify-end">
          <v-btn @click="slideoutClose" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row class="ma-0 py-2 d-flex justify-space-between">
          <h3 class="font-weight-bold pa-1" small><v-icon left>mdi-filter</v-icon> Filters</h3>
          <div v-if="isFetching" class="pa-1 d-flex align-center justify-center">
            <envizion-loader :size="48" :color="$vuetify.theme.dark ? '#2cc295' : '#03624c'" label="Loading filters" />
          </div>
          <v-btn text color="error" @click="resetAllFilters"> Reset all </v-btn>
        </v-row>
      </v-row>
    </template>
    <div class="d-flex py-3 px-6 flex-column filtersContainer" v-if="!isFetching">
      <v-expansion-panels accordion flat>
        <v-expansion-panel
          v-for="(filter, index) in filters.filter((elm) => elm.children.length > 0)"
          :key="`filter-${index}`">
          <v-expansion-panel-header class="text-subtitle-2 d-flex px-4">
            <!-- <img class="me-2" :src="getIcons(filter.icon)" alt="filter icon" /> -->
            <div class="d-flex">
              <img
                class="me-2"
                width="22"
                height="22"
                :src="getIcons($vuetify.theme.isDark ? filter.icon_dark : filter.icon)"
                alt="filter icon" />
              {{ filter.title }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="filter.title === 'Plant'">
              <v-checkbox
                hide-details
                
                :value="option"
                v-model="selectedfilters.plant"
                v-for="option in filter.children"
                :key="option">
                <template v-slot:label>
                  <span>{{ option }}</span>
                </template>
              </v-checkbox>
            </div>
            <div v-if="filter.title === 'Units'">
              <v-checkbox
                hide-details
                :value="option"
                v-model="selectedfilters.pltName"
                v-for="option in filter.children"
                :key="option">
                <template v-slot:label>
                  <span>{{ option }}</span>
                </template>
              </v-checkbox>
            </div>

            <div v-if="filter.title === 'Code'">
              <v-checkbox
                hide-details
                v-model="selectedfilters.code"
                :value="option"
                v-for="option in filter.children"
                :key="option">
                <template v-slot:label>
                  <span>{{ option }}</span>
                </template>
              </v-checkbox>
            </div>

            <div v-if="filter.title === 'Operation Temperature'">
              <v-list-item
                class="my-2"
                v-for="(option, index) in filter.children"
                :key="`temp-${index}`">
                <v-checkbox
                  class="my-0"
                  hide-details
                  v-model="selectedfilters.temperature"
                  :value="option">
                  <template v-slot:label>
                    <span v-if="getComparisonSymbol(option) === '≤' && option.judgCrr2 === '-∞'"
                      >Less than {{ `${option.judgCrr1} ${option.judgSymb}` }}</span
                    >
                    <span v-else-if="getComparisonSymbol(option) === '>' && option.judgCrr1 === '∞'"
                      >More than {{ `${option.judgCrr2} ${option.judgSymb}` }}</span
                    >
                    <span v-else>{{
                      `${option.judgCrr2} ${getComparisonSymbol(option)} ${option.judgCrr1} ${
                        option.judgSymb
                      }`
                    }}</span>
                  </template>
                </v-checkbox>
              </v-list-item>
            </div>

            <div v-if="filter.title === 'Operation Pressure'">
              <v-list-item
                class="my-2"
                v-for="(option, index) in filter.children"
                :key="`press-${index}`">
                <v-checkbox
                  class="my-0"
                  hide-details
                  v-model="selectedfilters.pressure"
                  :value="option">
                  <template v-slot:label>
                    <span v-if="getComparisonSymbol(option) === '≤' && option.judgCrr2 === '-∞'"
                      >Less than {{ ` ${option.judgCrr1} kg/cm²` }}</span
                    >
                    <span v-else-if="getComparisonSymbol(option) === '>' && option.judgCrr1 === '∞'"
                      >More than {{ `${option.judgCrr2} kg/cm²` }}</span
                    >
                    <span v-else>{{
                      `${option.judgCrr2} ${getComparisonSymbol(option)} ${option.judgCrr1} kg/cm²`
                    }}</span>
                  </template>
                </v-checkbox>
              </v-list-item>
            </div>

            <!-- <div v-if="filter.title === 'Code'"></div> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="d-flex flex-column">
        <v-card-title
          v-if="inspectionTreeFilters.filter((elm) => elm.children.length > 0).length > 0"
          class="text-subtitle-2 font-weight-medium px-0"
          style="color: var(--v-bg5-base)"
          >Inspection Tree</v-card-title
        >
        <v-expansion-panels accordion flat>
          <v-expansion-panel
            v-for="(filter, index) in inspectionTreeFilters.filter(
              (elm) => elm.children.length > 0,
            )"
            :key="`filter-${index}`">
            <v-expansion-panel-header class="text-subtitle-2 d-flex px-4">
              <div class="d-flex">
                <v-icon class="me-2">{{ filter.icon }}</v-icon>
                {{ filter.title }}
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-checkbox
                hide-details
                :value="option"
                v-model="selectedfilters[filter.name]"
                v-for="option in filter.children"
                :key="option">
                <template v-slot:label>
                  <span>{{ option }}</span>
                </template>
              </v-checkbox>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </slide-out>
</template>

<script>
  // import InspectionTree from '../components/inspectionTree.vue';

  export default {
    name: 'edit-task',
    data() {
      return {
        slideouts: {
          active: false,
          isLoading: false,
          isClosing: false,
          hasChanges: false,
        },
        isFetching: false,
        filters: [],
        inspectionTreeFilters: [],
      };
    },
    props: {
      nested: {
        type: Boolean,
        default: () => false,
      },
      viewerOpened: {
        type: Boolean,
        default: () => false,
      },
    },
    mounted() {
      this.sideOutMinSize = 300;
      this.$store.dispatch('GET_DASHBOARD_FILTERED_INSPECTION_TREE', {
        sortModel: {},
        pagingModel: {},
        assetId: this.$route.params.id,
        searchText: this.searchText,
      });
    },
    computed: {
      facility: {
        get() {
          return this.$store.getters['FACILITY/GET_FACILITY'];
        },
      },
      selectedfilters: {
        get() {
          return this.$store.getters['DASHBOARD_FILTERS/GET_FILTERS'];
        },
        set(val) {
          this.$store.commit('DASHBOARD_FILTERS/SET_FILTERS', val);
        },
      },
      sideOutMinSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_MINSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_MINSIZE', val);
        },
      },
      sideOutCurrentSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_CURRENTSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_CURRENTSIZE', val);
        },
      },
      dashboardFilters() {
        return this.$store.getters.GET_FILTERS;
      },
      inspectionsTree: {
        get() {
          return this.$store.getters['GET_INSPECTIONS_TREE'];
        },
      },
      inspectionCodesOptions: {
        get() {
          return this.$store.getters.GET_INSPECTION_CODES_OPTIONS;
        },
        set(value) {
          this.$store.commit('SET_INSPECTION_CODES_OPTIONS', value);
        },
      },
      selectedInspectionCodesOptions() {
        return this.inspectionCodesOptions.filter((f) => f.isChecked);
      },
      selectedCodes() {
        return this.selectedInspectionCodesOptions.map((o) => o.name).join(', ');
      },
      temperatureOptions() {
        return this.$store.getters.GET_INSPECTION_TEMPERATURE_OPTIONS;
      },
      pressureeOptions() {
        return this.$store.getters.GET_INSPECTION_PRESSURE_OPTIONS;
      },
      selectedExtraFilterOptions() {
        if (this.inspectionTempPresSelectedFilter == 'Operation Temperature') {
          return this.$store.getters.GET_INSPECTION_TEMPERATURE_OPTIONS.filter((t) => t.isChecked);
        } else if (this.inspectionTempPresSelectedFilter == 'Operation Pressure') {
          return this.$store.getters.GET_INSPECTION_PRESSURE_OPTIONS.filter((t) => t.isChecked);
        } else {
          return [];
        }
      },
      units() {
        return this.$store.getters['GET_UNITS'];
      },
      selectedUnits: {
        get: function () {
          return this.$store.getters['GET_SELECTED_UNITS'];
        },
        set: function (value) {
          this.$store.commit('SET_SELECTED_UNITS', value);
        },
      },
    },
    methods: {
      slideoutClose() {
        this.slideouts.active = false;
      },
      OnResize() {
        let DashboardFiltersSlideOut = this.$refs.dashboardSideout;
        this.sideOutCurrentSize = DashboardFiltersSlideOut.resizeValue;
      },
      open() {
        this.slideouts.active = true;
        this.isFetching = true;
       this.getData();
      },
      getData(){
        // this.$store.dispatch('GET_INSPECTIONS_UNITS', this.$route.params.id);
        this.$store
          .dispatch('GET_DASHBOARD_AVALIABLE_FILTERS', this.$route.params.id)
          .finally(() => {
            this.isFetching = false;
          });
      },
      resetAllFilters() {
        this.$store.commit('DASHBOARD_FILTERS/RESET_FILTERS');
      },
      openViewer() {
        this.$emit('openViewer');
      },
      clearCodeFilter() {
        this.inspectionCodesOptions.forEach((option) => {
          option.isChecked = true;
        });
      },
      getIcons(name) {
        return require(`@/assets/svgs/${name}.svg`);
      },
      getComparisonSymbol(option) {
        return option.judgCrr2 === '-∞'
          ? option.judgMkr1
          : option.judgCrr1 === '∞'
          ? option.judgMkr2
          : option.judgMkr1;
      },
      onUnitSelectionChange(selectedUnits) {
        this.units.forEach((unit) => {
          unit.isChecked = selectedUnits.some((selectedUnit) => selectedUnit.id === unit.id);
        });
        this.selectedUnits = this.units.filter((f) => f.isChecked);
      },
    },
    watch: {
      nested: {
        handler() {
          this.nested ? (this.sideOutCurrentSize = '80vw') : (this.sideOutCurrentSize = '35vw');
          this.nested ? (this.sideOutMinSize = '80vw') : (this.sideOutMinSize = '35vw');
        },
        deep: true,
      },
      selectedUnits() {
        this.$store.dispatch('GET_AVAILABLE_CODES_API');
      },
      dashboardFilters() {
        this.filters = [
          {
            title: 'Plant',
            icon: 'Oil_barrel',
            icon_dark: 'Oil_barrel_Dark',
            children: this.dashboardFilters.plant,
          },
          {
            title: 'Units',
            icon: 'solar_ruler-linear',
            icon_dark: 'solar_ruler-linear_Dark',
            children: this.dashboardFilters.pltName,
          },
          {
            title: 'Functional Locations',
            icon: 'Location_icon',
            icon_dark: 'Location_icon_Dark',
            children: this.dashboardFilters.funcLocation,
          },
          {
            title: 'Code',
            icon: 'document-link',
            icon_dark: 'document-link_Dark',
            children: this.dashboardFilters.code,
          },
          {
            title: 'Operation Temperature',
            icon: 'thermometer',
            icon_dark: 'thermometer_Dark',
            children: this.temperatureOptions,
          },
          {
            title: 'Operation Pressure',
            icon: 'speedometer',
            icon_dark: 'speedometer_Dark',
            children: this.pressureeOptions,
          },
         
        ];

        this.inspectionTreeFilters = [
          {
            title: 'COVE',
            name: 'insulation',
            icon: 'mdi-lan',
            children: this.dashboardFilters.insulation,
          },
          {
            title: 'Corrosion Loop',
            name: 'cl',
            icon: 'mdi-lan',
            children: this.dashboardFilters.cl,
          },
        ];
      },
      selectedfilters: {
        handler(val) {
          if (this.slideouts.active) {
            this.$emit('filtersChanges', val);
          }
        },
        deep: true,
      },
      facility(){
        this.resetAllFilters();
      }
    },
    components: {
    },
  };
</script>
<style lang="scss" scoped>
  .v-expansion-panel {
    margin-bottom: 10px;
    .v-expansion-panel-header,
    .v-expansion-panel-content {
      border-right: 1px solid var(--v-light-grey-base);
      border-left: 1px solid var(--v-light-grey-base);
    }
    .v-expansion-panel-header {
      border-top: 1px solid var(--v-light-grey-base);
      border-bottom: 1px solid var(--v-light-grey-base);
    }
    .v-expansion-panel-header--active {
      border-bottom: none;
    }
    .v-expansion-panel-content {
      border-bottom: 1px solid var(--v-light-grey-base);
    }
  }
  .filtersContainer .v-expansion-panel-content__wrap {
    padding: 0px 15px;
  }
  .filtersContainer .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
    flex: 0 1 auto;
  }
  .filtersContainer .v-list-item {
    border: 1px solid #edededb2;
    border-radius: 7px;
    cursor: pointer;
    &:hover {
      background-color: #f1f5ec;
      border: 1px solid var(--v-primary-lighten2);
    }
  }
  .filtersContainer .theme--dark .v-list-item {
    &:hover {
      background-color: var(--v-bg_Greeny_Gray-lighten1);
    }
  }
</style>
